import { PROJECT_UNIT_CREATE_REQUEST, PROJECT_UNIT_DELETE_CONFIRM, PROJECT_UNIT_DELETE_CONFIRM_DECLINE, PROJECT_UNIT_DELETE_FAILURE, PROJECT_UNIT_DELETE_REQUEST, PROJECT_UNIT_DELETE_SUCCESS, PROJECT_UNIT_EDIT_PAGE_REQUEST, PROJECT_UNIT_EDIT_PAGE_SUCCESS, PROJECT_UNITS_FAILURE, PROJECT_UNITS_REQUEST, PROJECT_UNITS_SUCCESS } from "../../redux/action_constant";

export interface ProjectUnitInterface {
    id: number;
    uuid: string;
    user_id: string;
    project_id: string;
    unit_name: string;
    status: projectUnitStatus;
    area: number;
    length: number;
    width: number;
    is_corner: boolean | string;
    comment: string;
    facing_direction: string;
    created_at: Date;
    updated_at: Date;
    is_registration: boolean;
    registration_power: string;
    is_mortgage: boolean | string;
};

export enum projectUnitStatus {
    BOOKED = 'BOOKED',
    AVAILABLE = 'AVAILABLE',
    SOLD = 'SOLD',
    DELETED = 'DELETED',
    NOT_AVAILABLE = 'NOT_AVAILABLE'
};

export interface ProjectUnitState {
    pending: boolean;
    error: any;
    loading: boolean;
    projectList: ProjectUnitInterface[];
    next_offset: Number;
    listCount: Number;
    editProject: ProjectUnitInterface;
    showDeleteModal: boolean;
    deleteProject: ProjectUnitInterface;
};

export interface ProjectRequestPayload {
    id: string;
    page: Number;
    keyword?: string;
    fromDate?: Date;
    toDate?: Date;
    limit?: Number;
};

export type ProjectsRequest = {
    type: typeof PROJECT_UNITS_REQUEST;
    payload: ProjectRequestPayload;
};

export interface ProjectsRequestSuccessPayload {
    list: ProjectUnitInterface[];
    next_offset: Number;
    count: Number;
};

export type ProjectsRequestSuccess = {
    type: typeof PROJECT_UNITS_SUCCESS;
    payload: any;
};

export type ProjectsRequestFailure = {
    type: typeof PROJECT_UNITS_SUCCESS | typeof PROJECT_UNITS_FAILURE | typeof PROJECT_UNIT_DELETE_CONFIRM_DECLINE | typeof PROJECT_UNIT_DELETE_REQUEST | typeof PROJECT_UNIT_DELETE_FAILURE | typeof PROJECT_UNIT_DELETE_SUCCESS;
    payload: string;
};

export type ProjectEditPageRequest = {
    type: typeof PROJECT_UNIT_EDIT_PAGE_REQUEST | typeof PROJECT_UNIT_EDIT_PAGE_SUCCESS | typeof PROJECT_UNIT_DELETE_CONFIRM | typeof PROJECT_UNIT_CREATE_REQUEST;
    payload: ProjectUnitInterface;
};

export type ProjectActions = ProjectsRequest | ProjectsRequestSuccess | ProjectsRequestFailure | ProjectEditPageRequest;